import apiClient from './api'

const CACHE_BASE_PATH = '/admin/categories/hybrid/cache'

export default {
  stats() {
    return apiClient.get(`${CACHE_BASE_PATH}/stats`)
  },
  list(page = 1, perPage = 25, search = '', options = {}) {
    return apiClient.get(CACHE_BASE_PATH, {
      params: { page, per_page: perPage, search, ...options },
    })
  },
  remove(normalizedSource) {
    return apiClient.delete(`${CACHE_BASE_PATH}/${encodeURIComponent(normalizedSource)}`)
  },
  update(normalizedSource, payload) {
    return apiClient.put(`${CACHE_BASE_PATH}/${encodeURIComponent(normalizedSource)}`, payload)
  },
  regenerate(normalizedSource) {
    return apiClient.post(`${CACHE_BASE_PATH}/${encodeURIComponent(normalizedSource)}/regenerate`)
  },
  clearAll() {
    return apiClient.delete(CACHE_BASE_PATH)
  },
}
